// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.count-badge[data-v-6237f2da] {\n  margin-left: 5px;\n}\n\n/* Your component's styles go here */\n", ""]);
// Exports
module.exports = exports;
